module.exports = __webpack_public_path__ + "assets/img/3201d740792855a3abbcf02ad47b02b3.png";